import { useEffect, useState, useSyncExternalStore } from 'react';

const ROOT_ATTR = 'data-window-resizing';
const DEFAULT_IDLE_MS = 150;

let isResizingGlobal = false;
let idleTimeoutId;
let listenerAttached = false;
const subscribers = new Set();

function notifySubscribers() {
  subscribers.forEach((listener) => listener());
}

function finishResizing() {
  isResizingGlobal = false;
  if (typeof document !== 'undefined') {
    document.documentElement.removeAttribute(ROOT_ATTR);
  }
  notifySubscribers();
}

function handleResize() {
  if (!isResizingGlobal) {
    isResizingGlobal = true;
    if (typeof document !== 'undefined') {
      document.documentElement.setAttribute(ROOT_ATTR, 'true');
    }
    notifySubscribers();
  }
  if (idleTimeoutId) clearTimeout(idleTimeoutId);
  idleTimeoutId = setTimeout(finishResizing, DEFAULT_IDLE_MS);
}

function subscribe(listener) {
  subscribers.add(listener);
  if (typeof window !== 'undefined' && !listenerAttached) {
    window.addEventListener('resize', handleResize, { passive: true });
    listenerAttached = true;
  }
  return () => {
    subscribers.delete(listener);
    if (subscribers.size === 0 && typeof window !== 'undefined' && listenerAttached) {
      window.removeEventListener('resize', handleResize);
      listenerAttached = false;
      if (idleTimeoutId) clearTimeout(idleTimeoutId);
      finishResizing();
    }
  };
}

function getSnapshot() {
  return isResizingGlobal;
}

/**
 * Tracks active window resize so heavy layout transitions can be paused.
 */
export function useWindowResizeSession() {
  return useSyncExternalStore(subscribe, getSnapshot, () => false);
}

export function readWindowResizing() {
  return isResizingGlobal;
}
